import { InputGroupControl } from '@connected/ui/components/input';
import { InputGroup } from '@connected/ui/components/input-group';
import { cn } from '@connected/ui/lib/utils';

import type { NumberFieldProps } from './number';

import { NumberField } from './number';

export type Currencies = 'USD' | 'EUR' | 'GBP' | 'JPY' | 'CNY';

function CurrencySymbol({
    currency,
    className,
}: {
    currency: Currencies;
    className?: string;
}) {
    let symbol = '€';

    switch (currency) {
        case 'USD':
            symbol = '$';
            break;
        case 'EUR':
            symbol = '€';
            break;
        case 'GBP':
            symbol = '£';
            break;
        case 'JPY':
            symbol = '¥';
            break;
        case 'CNY':
            symbol = '¥';
            break;
    }

    return (
        <span className={cn('text-xl font-medium leading-3 text-text-tertiary', className)}>{symbol}</span>
    );
}

export type CurrencyFieldProps = NumberFieldProps & {
    currency: Currencies;
};

export function CurrencyField({ currency, className, maxPrecision = 2, ...props }: CurrencyFieldProps) {
    return (
        <InputGroup>
            <InputGroup.Addon>
                <CurrencySymbol currency={currency} />
            </InputGroup.Addon>
            <NumberField
                data-slot="input-group-control"
                customInput={InputGroupControl}
                className={cn('flex-1 !border-none !shadow-none !ring-0 !outline-none focus:!border-none focus:!shadow-none focus:!ring-0 focus-visible:!ring-0 hover:!border-none hover:!shadow-none', className)}
                maxPrecision={maxPrecision}
                {...props}
            />
        </InputGroup>
    );
}

CurrencyField.displayName = 'CurrencyField';
